import { render, staticRenderFns } from "./SummaryTable.vue?vue&type=template&id=0f228b8a&"
import script from "./SummaryTable.vue?vue&type=script&lang=js&"
export * from "./SummaryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRating } from 'vuetify/lib/components/VRating';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDataTable,VRating,VSheet,VTextField})
